export default __webpack_public_path__ + "static/media/Exhibitors.c8a9505900b26e3016f8a0fece70c3a6.webp";